import { render, staticRenderFns } from "./AppDevelopmentCta.vue?vue&type=template&id=4bf1b134&scoped=true"
import script from "./AppDevelopmentCta.vue?vue&type=script&lang=js"
export * from "./AppDevelopmentCta.vue?vue&type=script&lang=js"
import style0 from "./AppDevelopmentCta.vue?vue&type=style&index=0&id=4bf1b134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1b134",
  null
  
)

export default component.exports